export const ZONE_OPTIONS = [
    { value: 'CIUDAD DE MEXICO', text: 'CIUDAD DE MEXICO' },
    { value: 'HGO', text: 'HGO' },
    { value: 'JALISCO', text: 'JALISCO' },
    { value: 'MEXICO', text: 'MEXICO' },
    { value: 'NUEVO LEON', text: 'NUEVO LEON' },
]
